var _circle, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearchnotfound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.5,
    stroke: "url(#paint0_linear_2725_7733)",
    strokeWidth: 5,
    strokeDasharray: "8 8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 80V55C5.82187 58.7879 14.4286 66.3636 26.2804 66.3636C38.1323 66.3636 45.328 58.7879 47.4444 55V80",
    stroke: "url(#paint1_linear_2725_7733)",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7653 49.3482C15.521 47.3152 14.1113 44.3778 14.1113 41.1111C14.1113 34.9746 19.0859 30 25.2224 30C31.3589 30 36.3335 34.9746 36.3335 41.1111C36.3335 44.3778 34.9238 47.3152 32.6796 49.3482",
    stroke: "url(#paint2_linear_2725_7733)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 76V51C5.82187 54.7879 14.4286 62.3636 26.2804 62.3636C38.1323 62.3636 45.328 54.7879 47.4444 51V76",
    stroke: "#7B8484",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7653 45.3482C15.521 43.3152 14.1113 40.3778 14.1113 37.1111C14.1113 30.9746 19.0859 26 25.2224 26C31.3589 26 36.3335 30.9746 36.3335 37.1111C36.3335 40.3778 34.9238 43.3152 32.6796 45.3482",
    stroke: "#7B8484",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2725_7733",
    x1: 80,
    y1: -0.00000476837,
    x2: 0.00000476837,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2725_7733",
    x1: 25.2222,
    y1: 55,
    x2: 25.2222,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758080",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2725_7733",
    x1: 25.2224,
    y1: 30,
    x2: 25.2224,
    y2: 49.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758080",
    stopOpacity: 0.75
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchnotfound);
export default __webpack_public_path__ + "static/media/ic_searchnotfound.756b8c166464c0b27a832df7797e90f2.svg";
export { ForwardRef as ReactComponent };